import React from "react";
import NewArrivals from "../Components/cards/cards";
import PopularSales from "../Components/cards/popular-Sales";

const Shop = () => {
  return (
    <>
      <NewArrivals />
      <PopularSales />
    </>
  );
};

export default Shop;
